import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Container, Row } from "reactstrap";
import ViewMapping from "./components/ViewMapping";
import PageHeader from "../../../shared/components/PageHeader";
import { viewIissuerDomainMapping, resetView } from "../actions/issuerDomainMap.actions";

const ViewIssuerMapping = ({ dispatch, mapping, match }) => {
  function fetchMapping() {
    dispatch(viewIissuerDomainMapping(match.params.domainCode));
  }

  useEffect(() => {
    if (match.params.domainCode) {
      dispatch(viewIissuerDomainMapping(match.params.domainCode));
    }
    return () => {
      dispatch(resetView());
    };
  }, [dispatch, match.params.domainCode]);

  return (
    <Container>
      <PageHeader header="View Mapping" subheader="View issuer mapping information" />
      <Row>
        <ViewMapping
          domainCode={match.params.domainCode}
          mapping={mapping}
          fetchData={fetchMapping}
        />
      </Row>
    </Container>
  );
};

export default connect(state => ({
  mapping: state.getIssuerDomainMapping
}))(ViewIssuerMapping);
